module.exports = __webpack_public_path__ + "static/media/carousel.d243be00.jpg";